import styled from 'styled-components'

interface Props {
  readonly location?: 'over' | 'under' | 'left' | 'right';
  readonly variant?: 'dark' | 'light';
  readonly noArrow?: boolean;
  readonly shadow?: boolean;
};

export const Tooltip = styled.div<Props>`
  position: absolute;
  z-index: 2;
  top: 135%;
  left: 50%;
  right: auto;
  transform: translate(-50%, -50%);
  padding: 5px 10px;

  font-size: 0.8rem;
  text-transform: initial;
  text-align: center;
  white-space: nowrap;
  color: ${props => props.variant === 'light' ? 'var(--todo_333)' : 'var(--white)'};

  border-radius: 2px;
  opacity: 0;
  background: ${props => props.variant === 'light' ? 'var(--white)' : 'var(--todo_333)'};
  box-shadow: ${props => props.shadow ? '0 8px 20px rgba(0, 0, 0, 0.2)' : 'none'};

  pointer-events: none;

  transition: transform 100ms ease-in-out, opacity 50ms linear;
  transition-delay: 10ms;

  ${(props: Props) => !props.noArrow && `
    &:before {
      content: '';
      position: absolute;
      top: -0.2rem;
      left: 50%;
      right: auto;
      border-radius: 2px;
      margin-left: -0.5rem;
      margin-top: 0;
      width: 1rem;
      height: 1rem;
      transform: rotate(45deg);
      z-index: 1;
      background: ${props!.variant === 'light' ? 'var(--white)' : 'var(--todo_333)'};
    }
  `}
`

export const TooltipWrapper = styled.div<Props>`
  position: relative;

  ${Tooltip} {
    ${({ location, noArrow }) => {
    switch (location) {
      case 'over':
        return `
            top: -130%;
            left: 50%;
            right: auto;
            transform: translate(-50%, 50%);

            ${!noArrow
            ? `
              &:before {
                top: 1rem;
                left: 50%;
                right: auto;
                margin-left: -0.5rem;
                margin-top: 0;
              }
            `
            : ''}
          `
      case 'left':
        return `
            top: 50%;
            left: auto;
            right: 135%;
            transform: translate(8px, -50%);

            ${!noArrow
            ? `
              &:before {
                top: 50%;
                left: auto;
                right: -0.2rem;
                margin-left: 0;
                margin-top: -0.5rem;
              }
            `
            : ''}
          `
      case 'right':
        return `
            top: 50%;
            left: 135%;
            right: auto;
            transform: translate(-8px, -50%);

            ${!noArrow
            ? `
              &:before {
                top: 50%;
                left: -0.2rem;
                right: auto;
                margin-left: 0;
                margin-top: -0.5rem;
              }
            `
            : ''}
          `
      case 'under':
      default:
        return `
            top: 135%;
            left: 50%;
            right: auto;
            transform: translate(-50%, -50%);

            ${!noArrow
            ? `
              &:before {
                top: -0.2rem;
                left: 50%;
                right: auto;
                margin-left: -0.5rem;
                margin-top: 0;
              }
            `
            : ''}
          `
    }
  }}
  }

  &:hover ${Tooltip} {
    opacity: 1;
    transform: ${({ location }) =>
    location === 'left' || location === 'right'
      ? 'translate(0, -50%)'
      : 'translate(-50%, 0)'};
  }
`
